import React, { useCallback, useEffect, useMemo, useState } from 'react';
import * as api from '../api';
import Register from '../../hr/components/Register';
import { can, usePyMeta } from '../py';

// Stephanet's Public Holidays (catalog E("py-holidays", …, "holidays")): its register view over the holiday list — the same
// public_holidays HR & People uses. Edited by whoever holds Payroll Set-up.
const TYPES = ['Public Holiday', 'Religious Holiday', 'Company Holiday'];

export default function Holidays() {
  const [meta] = usePyMeta();
  const [states, setStates] = useState([]);
  useEffect(() => { api.holidays().then(r => setStates(r.states)).catch(() => {}); }, []);
  const load = useCallback(() => api.holidays().then(r => [...r.holidays].sort((a, b) => b.code.localeCompare(a.code))), []);
  const body = d => ({ holiday_date: d.holiday_date, name: d.name, holiday_type: d.holiday_type, state_id: d.state_id || null,
    recurring: !!d.recurring, paid: !!d.paid, active: !!d.active, description: d.description || null });
  const res = useMemo(() => ({
    key: 'public_holidays', label: 'Holiday', plural: 'Holidays', title: r => r.name, load,
    create: d => api.saveHoliday(null, body(d)),
    update: (r, d) => api.saveHoliday(r.id, body({ ...r, ...d })),
    remove: r => api.deleteHoliday(r.id),
    search: ['code', 'name', 'holiday_type', 'state', 'holiday_date'],
    defaults: { holiday_type: 'Public Holiday', recurring: false, paid: true, active: true },
    fields: [
      { name: 'code', label: 'Holiday ID', list: true, form: false },
      { name: 'holiday_date', label: 'Date', type: 'date', required: true, list: true },
      { name: 'name', label: 'Holiday Name', required: true, list: true },
      { name: 'holiday_type', label: 'Type', type: 'select', options: TYPES, list: true },
      { name: 'state_id', label: 'State', type: 'select', options: states.map(s => ({ value: s.id, label: s.name })), list: false },
      { name: 'state', label: 'State', list: true, form: false },
      { name: 'recurring', label: 'Recurring Yearly', type: 'boolean', list: true },
      { name: 'paid', label: 'Paid', type: 'boolean', list: true },
      { name: 'active', label: 'Active', type: 'boolean', list: true },
      { name: 'description', label: 'Description', type: 'textarea' },
    ],
  }), [load, states]);
  return <Register res={res} canEdit={can(meta, 'py-holidays')} />;
}
